import {Button, Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {textHandle} from 'presentation/utils/textHandle';
import React from 'react';
import {
	StyledButtonContainer,
	StyledDot,
	StyledItemContainer,
	StyledStatusContainer,
	StyledStatusTypography,
} from './styles';
import {ExamItemListDrawerProps} from './types';
import {useMedicalReportItem} from 'presentation/modules/examResults/hooks/useMedicalReportItem';

const {buttonShowImage, inAnalysis, releasedIn} =
	translations['pt-br'].privateFlow.myHospitalization.exams.drawer;

export const ExamItemListDrawer = ({exam, isFirst}: ExamItemListDrawerProps) => {
	const {openImageUrl, urlPacsmobile} = useMedicalReportItem({
		medicalReport: exam,
	});

	return (
		<StyledItemContainer $first={isFirst}>
			<Stack>
				<Typography>
					{textHandle(exam.dsProcedimento.toLowerCase()).capitalizeFirstLetter()}
				</Typography>
				<StyledStatusContainer>
					<StyledDot $isReleased={!!exam.dtLaudo} />
					<StyledStatusTypography>
						{exam.dtLaudo ? `${releasedIn}${exam.dtLaudo.split(' ')[0]}` : inAnalysis}
					</StyledStatusTypography>
				</StyledStatusContainer>
			</Stack>
			<StyledButtonContainer>
				{urlPacsmobile ? (
					<Button variant="text" size="large" onClick={openImageUrl}>
						{buttonShowImage}
					</Button>
				) : null}
			</StyledButtonContainer>
		</StyledItemContainer>
	);
};
